import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

import { colors } from "../../../theme";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    display: "flex",
    paddingRight: "15px",
    gap: "20px",
    width: "100%",
    fontSize: "12px",
    fontWeight: "100",
    marginLeft: "12px",
    marginTop: "3px",
  },
}));

export const DateWrap = styled.div`
  display: grid;
  width: 100%;
`;

export const Container = styled.article`
  width: 100%;
  background-color: ${colors.white};
  display: inline-block;
  position: relative;
  flex-direction: column;
  justify-content: center;
  height: auto;
`;

export const ButtonContainerInferior = styled.section`
  float: right;
  right: 0;
  display: inline-block;
`;

export const ButtonContainerTools = styled.section`
  position: absolute;
  bottom: -15px;
  right: 0;
`;

export const WrapperDatePicker = styled.section`
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
  display: inline-block;
  background-color: white;
`;

export const ContainerTextField = styled.div`
  width: 100%;
`;

export const DivHelperTextTitle = styled.div`
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 12px;
`;
